// src/data/newsData.js

const news = [
  {
    id: 10,
    title: 'Avis d’appel d’offres : fourniture de mobilier de bureau à Bamako',
    excerpt: 'ENGIM Mali lance un appel d’offres pour sélectionner une entreprise chargée de la fourniture de mobilier de bureau à Bamako. Date limite de dépôt : 11 mai 2026 à 16h30.',
    content: `ENGIM Mali envisage d’attribuer un marché de biens pour la sélection d’une entreprise de fourniture de mobilier de bureau à Bamako, dans le cadre des projets Karité, RESTART, ainsi que pour d’éventuels projets futurs et autres activités de la mission ENGIM au Mali.

Référence publique : DAO2026/EMLI/N°006.

Le dossier d’appel d’offres comprend les instructions de soumission, les termes de référence, les clauses contractuelles et le cahier des charges. Les candidats doivent soumettre l’ensemble des formulaires et documents requis conformément aux exigences du dossier.

Le dossier de candidature peut être retiré auprès du bureau d’ENGIM Mali, situé à Faso Kanu, non loin du Bureau du Conseiller économique et commercial près de l’Ambassade de la République Populaire de Chine à Bamako.

La date limite de dépôt des propositions est fixée au lundi 11 mai 2026 à 16h30, heure de Bamako. Info line : 74 43 37 02.`,
    date: '11 avril 2026',
    image: '/images/avis-appel-offres-mobilier-bureau-engim-mali-2026.jpg',
    slug: 'avis-appel-offres-mobilier-bureau-engim-mali-2026',
    link: '/actualites/avis-appel-offres-mobilier-bureau-engim-mali-2026',
    downloadUrl: '/documents/avis-appel-offres-mobilier-bureau-engim-mali-2026.pdf'
  },
  {
    id: 9,
    title: 'Prolongation de l’avis de recrutement : Spécialiste Humanitaire',
    excerpt: 'La date limite de dépôt des candidatures est prolongée jusqu’au lundi 9 novembre 2026 à 17h00.',
    content: `Dans le cadre de la mise en œuvre de son plan d’action 2026-2027, avec le soutien de la DG ECHO, la Plateforme des ONG Nationales Actives dans l’Humanitaire (PONAH) recrute un(e) Spécialiste Humanitaire pour appuyer, accompagner et soutenir la Plateforme.

Le poste est basé à Bamako, avec des déplacements dans les régions. Il s’agit d’un contrat à durée déterminée (CDD) de cinq (5) mois, placé sous la supervision directe du Secrétaire Permanent.

Les candidat(e)s intéressé(e)s doivent soumettre un CV détaillé, une lettre de motivation, trois références professionnelles ainsi que les copies certifiées des diplômes et attestations de travail.

La date limite de dépôt des candidatures est fixée au lundi 9 novembre 2026 à 17h00. Les dossiers peuvent être envoyés par courrier électronique à ponah.mali@gmail.com ou déposés physiquement au Secrétariat permanent de la PONAH, situé dans les locaux de l’AMSS à Banankabougou, Rue 737, Porte 419.`,
    date: '21 octobre 2026',
    image: '/images/avis-recrutement-specialiste-humanitaire-ponah.jpg',
    slug: 'avis-recrutement-specialiste-humanitaire-ponah-2026',
    link: '/actualites/avis-recrutement-specialiste-humanitaire-ponah-2026',
    downloadUrl: '/documents/AvisderecrutementSpecialisteHumanitairePONAH.pdf'
  },
  {
    id: 1,
    title: 'Validation de la Stratégie Nationale de Localisation',
    excerpt: 'Les 9 axes stratégiques ont été validés lors de l\'atelier de restitution.',
    date: '30 octobre 2024',
    image: '/images/news1-new.jpg',
    slug: 'validation-strategie-nationale-localisation',
    link: '/actualites/validation-strategie-nationale-localisation'
  },
  {
    id: 2,
    title: 'Formation de 360 acteurs sur la gestion des risques de sécurité',
    excerpt: '72 OSC ont bénéficié d\'une formation complète dans 3 régions.',
    date: '15 décembre 2024',
    image: '/images/news2.jpg',
    slug: 'formation-grs-osc-2024',
    link: '/actualites/formation-grs-osc-2024'
  },
  {
    id: 3,
    title: 'Mission de plaidoyer fructueuse au Qatar',
    excerpt: 'Des promesses de financement et de nouveaux partenariats ont été obtenus.',
    date: '20 septembre 2024',
    image: '/images/news3.jpg',
    slug: 'mission-plaidoyer-qatar-2024',
    link: '/actualites/mission-plaidoyer-qatar-2024'
  },
  {
    id: 4,
    title: 'Lancement du Baromètre de la Localisation',
    excerpt: 'Les bases méthodologiques pour évaluer les progrès ont été posées.',
    date: '30 mai 2024',
    image: '/images/news4.jpg',
    slug: 'lancement-barometre-localisation',
    link: '/actualites/lancement-barometre-localisation'
  },
  {
    id: 5,
    title: 'Table Ronde sur l\'état d\'avancement des recommandations',
    excerpt: 'Point d\'étape sur les 13 recommandations du Forum National.',
    date: '3 mai 2024',
    image: '/images/news5.jpg',
    slug: 'table-ronde-recommandations-forum',
    link: '/actualites/table-ronde-recommandations-forum'
  },
  {
    id: 6,
    title: 'Création officielle de la PONAH',
    excerpt: 'La PONAH a été officiellement enregistrée en janvier 2024.',
    date: '18 janvier 2024',
    image: '/images/news6.jpg',
    slug: 'creation-officielle-ponah',
    link: '/actualites/creation-officielle-ponah'
  }
];

export default news;
